export default {
    listagem: {
        titulo_pagina: 'List of File Formats',
        novo: 'Add New File Format',
        table: {
            empty: 'No Format Found',
            nome: 'Name',
            classe: 'Class',
            editar: 'Edit'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Create New Format',
            editar: 'Edit Format'
        },
        fields: {
            nome: {
                label: 'Name',
                description: 'Format Name'
            },
            classe: {
                label: 'Class',
                description: 'Class that executes the format'
            },
            extensao: {
                label: 'Extension',
                description: 'File extension generated by parser'
            },
            has_cloud_function: {
                label: 'Cloud Function',
                description: 'File format has conversion Cloud Function'
            },
            cloud_function: {
                label: 'Cloud Function Name',
                description: 'Cloud Function that performs the conversion',
                selecionar: 'Select...'
            },
            status: {
                label: 'Status',
                description: 'Format active or inactive status'
            },
            botao_salvar : 'Save Format'
        },
        create: {
            success: 'Format successfully created!',
            error: 'Error creating Format!'
        },
        update: {
            success: 'Format successfully edited!',
            error: 'Error editing Format!'
        }
    }
}
